import Vue from 'vue'
import Vuex from 'vuex'
import { clientModule } from "./clientModule";
import { metalicosModule } from './metalicosModule';
import { panelTerniumModule } from './panelTerniumModule';
import { userModule } from "./userModule";
import { destiniesModule } from "./destiniesModule";
import { servicesModule } from "./servicesModule";
import { isocinduModule } from './isocinduModule';
import { otrosModule } from './otrosModule';
import Fuse from "fuse.js";

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    fetching: false,
    errorFetching: false,
    all: [],
    selected: [],
    fuse: [],
    total: 0,
    iva: 0,
    subtotal: 0,
    pesoTotal: 0,
    pago: null,
    fabricacion: null,
    entrega: null,
    observaciones: null,
    current: null,
    invalid: true,
    warningsPeso: [],
  },
  mutations: {
    setFetching(state, newValue) {
      state.fetching = newValue;
    },
    setErrorFetching(state, newValue) {
      state.errorFetching = newValue;
    },
    setAll(state, newValue) {
      state.all = newValue;
    },
    setSelected(state, newValue) {
      state.selected = newValue;
    },
    setFuse(state, newValue) {
      state.fuse = newValue;
    },
    setTotal(state, newValue) {
      state.total = newValue;
    },
    setIVA(state, newValue) {
      state.iva = newValue;
    },
    setSubtotal(state, newValue) {
      state.subtotal = newValue;
    },
    setPesoTotal(state, newValue) {
      state.pesoTotal = newValue;
    },
    setPago(state, newValue) {
      state.pago = newValue;
    },
    setFabricacion(state, newValue) {
      state.fabricacion = newValue;
    },
    setEntrega(state, newValue) {
      state.entrega = newValue;
    },
    setObservaciones(state, newValue) {
      state.observaciones = newValue;
    },
    setCurrent(state, newValue) {
      state.current = newValue;
    },
    setInvalid(state, newValue) {
      state.invalid = newValue;
    },
    setWarningsPeso(state, newValue) {
      state.warningsPeso = newValue;
    },
  },
  actions: {
    async getAll({ state, commit, dispatch }) {
      try {
        await dispatch("getMetalicos");
        await dispatch("getPanelTernium");
        await dispatch("getIsocindu");
        await dispatch("getOtros");

        const all = state.all
          .concat(state?.metalicos?.allMetalicos)
          .concat(state?.panelTernium?.allPanelTernium)
          .concat(state?.isocindu?.allIsocindu)
          .concat(state?.otros?.allOtros);
        commit("setAll", all);
        commit("setFuse", new Fuse([...state.all], {
          keys: ["attributes.codigo", "attributes.descripcion"],
        }));
      } catch (error) {
        commit("setAll", []);
      }

    },
    addProduct({ state, commit, dispatch }, item) {
      switch (item?.attributes?.familia) {
        case "metalicos":
          dispatch("addMetalico", item);
          break;
        case "panel_ternium":
          dispatch("addPanelTernium", item);
          break;
        case "panel_isocindu":
          dispatch("addIsocindu", item);
          break;
        case "otros":
          dispatch("addOtro", item);
          break;
        default:
          console.warn("Family could not be identified. Skipping product");
          return;
      }
      const converted = [
        ...state.metalicos.selectedMetalicos,
        ...state.panelTernium.selectedPanelTernium,
        ...state.isocindu.selectedIsocindu,
        ...state.otros.selectedOtros,
      ]
      commit("setSelected", converted);
    },
    updateProducts({ state, commit, dispatch }, item) {
      switch (item?.familia) {
        case "metalicos":
          dispatch("updateMetalicos", item);
          break;
        case "panel_ternium":
          dispatch("updatePanelTernium", item);
          break;
        case "panel_isocindu":
          dispatch("updateIsocindu", item);
          break;
        case "otros":
          dispatch("updateOtros", item);
          break;
        default:
          console.warn("Family could not be identified. Skipping product");
          return;
      }
      const converted = [
        ...state.metalicos.selectedMetalicos,
        ...state.panelTernium.selectedPanelTernium,
        ...state.isocindu.selectedIsocindu,
        ...state.otros.selectedOtros,
      ]
      commit("setSelected", converted);
    },
    deleteProduct({ state, commit, dispatch }, item) {
      switch (item?.familia) {
        case "metalicos":
          dispatch("deleteMetalico", item);
          break;
        case "panel_ternium":
          dispatch("deletePanelTernium", item);
          break;
        case "panel_isocindu":
          dispatch("deleteIsocindu", item);
          break;
        case "otros":
          dispatch("deleteOtro", item);
          break;
        default:
          console.warn("Family could not be identified. Skipping product");
          return;
      }
      const converted = [
        ...state.metalicos.selectedMetalicos,
        ...state.panelTernium.selectedPanelTernium,
        ...state.isocindu.selectedIsocindu,
        ...state.otros.selectedOtros,
      ]
      commit("setSelected", converted);
    },
    updateQuotationTotals({ state, commit }) {
      let total = 0;
      let peso = 0;

      for (const item of state.metalicos.selectedMetalicos) {
        total += parseFloat(item.total_local);
        peso += parseFloat(item.peso_calculado);
      }
      for (const item of state.panelTernium.selectedPanelTernium) {
        total += parseFloat(item.total_local);
        peso += parseFloat(item.peso_calculado);
      }
      for (const item of state.isocindu.selectedIsocindu) {
        total += parseFloat(item.total_local);
        peso += parseFloat(item.peso_calculado);
      }
      for (const item of state.otros.selectedOtros) {
        total += parseFloat(item.total_local);
        peso += parseFloat(item.peso_calculado);
      }
      for (const item of state.services.selectedServices) {
        total += parseFloat(item.total_local);
      }

      commit("setPesoTotal", peso);
      commit("setTotal", total);
      commit("setIVA", total * 0.16);
      commit("setSubtotal", total - total * 0.16);
    },
    validate({ state, commit }) {
      if (state.current == null || state.current.id == null) {
        commit('setInvalid', true);
        return;
      }

      if (state.selected?.length == 0 && state.selectedServices?.length == 0) {
        commit("setInvalid", true);
        return;
      }

      commit('setInvalid', false);
    },
    clearQuotationData({ commit }) {
      commit('setSelectedMetalicos', []);
      commit('setSelectedPanelTernium', []);
      commit('setSelectedIsocindu', []);
      commit('setSelectedOtros', []);
      commit('setSelected', []);
      commit('setSelectedServices', []);
      commit('setWarningsPeso', []);
      commit('setSelectedClient', null);
      commit('setName', null);
      commit('setEmail', null);
      commit('setPhone', null);
      commit('setProccessedDiscounts', []);
      commit("setPesoTotal", 0);
      commit("setTotal", 0);
      commit("setIVA", 0);
      commit("setSubtotal", 0);
      commit('setPago', null);
      commit('setFabricacion', null);
      commit('setEntrega', null);
      commit('setObservaciones', null);
      commit('setSelectedState', null);
      commit('setSelectedDestiny', null);
      commit('setInvalid', true);
    },
    prepopulate({ state, commit, dispatch }, data) {
      dispatch("clearQuotationData");

      commit("setCurrent", data);
      dispatch("validate");

      commit(
        "setSelectedClient",
        data?.attributes?.cliente?.data?.id ?? null
      );

      commit(
        "setSelectedDestiny",
        data?.attributes?.destino ?? null
      );

      for (const p of data?.attributes?.productos) {
        switch (p.familia) {
          case "metalicos":
            commit("setSelectedMetalicos", [...state.metalicos.selectedMetalicos, p]);
            break;
          case "panel_ternium":
            commit("setSelectedPanelTernium", [...state.panelTernium.selectedPanelTernium, p]);
            break;
          case "panel_isocindu":
            commit("setSelectedIsocindu", [...state.isocindu.selectedIsocindu, p]);
            break;
          case "otros":
            commit("setSelectedOtros", [...state.otros.selectedOtros, p]);
            break;
          default:
            console.warn("Family could not be identified. Skipping product");
            return;
        }
      }

      const converted = [
        ...state.metalicos.selectedMetalicos,
        ...state.panelTernium.selectedPanelTernium,
        ...state.isocindu.selectedIsocindu,
        ...state.otros.selectedOtros,
      ]
      commit("setSelected", converted);

      commit(
        "setSelectedServices",
        data?.attributes?.servicios ?? []
      );

      dispatch("updateQuotationTotals");

      commit("setEmail", data?.attributes?.correo_cliente ?? null);

      commit(
        "setPhone",
        data?.attributes?.telefono_cliente ?? null
      );

      commit(
        "setPago",
        data?.attributes?.pago ?? null
      );

      commit(
        "setFabricacion",
        data?.attributes?.fabricacion ?? null
      );

      commit(
        "setEntrega",
        data?.attributes?.entrega ?? null
      );

      commit(
        "setObservaciones",
        data?.attributes?.observaciones ?? null
      );

      (state);
    },
  },
  modules: {
    user: userModule,
    client: clientModule,
    metalicos: metalicosModule,
    panelTernium: panelTerniumModule,
    isocindu: isocinduModule,
    otros: otrosModule,
    destinies: destiniesModule,
    services: servicesModule,
  }
});